import { buttonStyle } from 'components/buttons/buttonStyle';
import FeatureFlagged from 'components/featureflag/FeatureFlagged.tsx';
import TextInput from 'components/forms/inputs/rhf-inputs/TextInput';
import { ModalFooterSimple } from 'components/modals/ModalFooterSimple';
import { ModalHeader } from 'components/modals/ModalHeader';
import { Button } from 'components/ui/button';
import { Control } from 'react-hook-form';
import { FeatureFlag } from 'types/features.ts';
import { InvoiceMatterNameDetailsForm } from 'types/invoice-details';
import { t } from 'utils/getTranslations';

interface Props {
    onClose: () => void;
    onSubmit: () => void;
    control: Control<InvoiceMatterNameDetailsForm>;
}

const InvoiceTimecardEditModal = (props: Props) => {
    const { onSubmit, onClose, control } = props;

    const handleOnSave = () => {
        onSubmit();
        onClose();
    };

    return (
        <>
            <ModalHeader title={t('invoices.details.case-name')} onCancel={onClose} />
            <div className="h-full overflow-y-auto p-6 max-sm:px-4">
                <div className="flex flex-col gap-6">
                    <p className="text-body1 text-primary">{t('invoices.details.case-name-amendments')}</p>
                    <TextInput
                        control={control}
                        label="invoices.details.case-name-on-invoice"
                        name="invoiceMatterName"
                        maxLength={500}
                    />
                    <FeatureFlagged
                        action="show"
                        mode="any"
                        flag={[FeatureFlag.LOCALIZED_FIELDS, FeatureFlag.LOCALIZED_FIELDS_INVOICES]}
                    >
                        <TextInput
                            control={control}
                            label="invoices.details.case-name-on-invoice-local-lang"
                            name="invoiceMatterNameLocalLanguage"
                            maxLength={500}
                        />
                    </FeatureFlagged>
                    <TextInput
                        control={control}
                        label="invoices.details.case-name-on-spec"
                        name="specificationInvoiceMatterName"
                        maxLength={500}
                    />
                    <FeatureFlagged
                        action="show"
                        mode="any"
                        flag={[FeatureFlag.LOCALIZED_FIELDS, FeatureFlag.LOCALIZED_FIELDS_INVOICES]}
                    >
                        <TextInput
                            control={control}
                            label="invoices.details.case-name-on-spec-local-lang"
                            name="specificationInvoiceMatterNameLocalLanguage"
                            maxLength={500}
                        />
                    </FeatureFlagged>
                </div>
            </div>
            <ModalFooterSimple
                buttons={[
                    <Button key="cancel" {...buttonStyle({ variant: 'outlined', color: 'primary' })} onClick={onClose}>
                        {t('cancel')}
                    </Button>,
                    <Button
                        key="update-timecard"
                        {...buttonStyle({ variant: 'contained', color: 'secondary' })}
                        onClick={handleOnSave}
                    >
                        {t('save')}
                    </Button>,
                ]}
            />
        </>
    );
};

export default InvoiceTimecardEditModal;
